import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null, hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error, hasError: true };
  }

  override render(): ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return (
      this.props.fallback ?? (
        <div
          style={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            minHeight: "200px",
            padding: "2rem",
          }}
        >
          <h2 style={{ fontSize: "1.125rem", fontWeight: 600, marginBottom: "0.5rem" }}>
            Something went wrong
          </h2>
          <p style={{ color: "var(--text-muted)", fontSize: "0.875rem" }}>
            {this.state.error?.message}
          </p>
          <button
            onClick={() => {
              this.setState({ error: null, hasError: false });
            }}
            style={{
              backgroundColor: "var(--primary)",
              border: "none",
              borderRadius: "var(--radius)",
              color: "#fff",
              cursor: "pointer",
              fontSize: "0.875rem",
              marginTop: "1rem",
              padding: "0.5rem 1rem",
            }}
          >
            Try again
          </button>
        </div>
      )
    );
  }
}
